module.exports = "/virtual-football-league/img/amblems/left/Spain/Fake_AtleticoMadrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Spain/Fake_AtleticoMadrid.png
// module id = 2045
// module chunks = 4